import { getJSON } from 'wix-fetch';
import feraConfig from "public/config";
let store = null;

export async function checkIfFeraNeedsSetup(appInstanceId) {
    const result = store ?? await fetchFeraStore(appInstanceId);

    console.log('[Fera Wix Plugin] Received response from API:', result);
    if (result && (['app_instance_id_not_found', 'store_uninstalled'].includes(result.code) || (result.js_version && result.js_version < 3.0))) {
        return true;
    } else {
        return false;
    }
}

// GET call using getJSON
export async function fetchFeraStore(appInstanceId) {
	console.log("Checking if installed...", appInstanceId);
    const url = new URL(`${ feraConfig.apiUrl }v3/public/store.json`);
    const params = {};
    
    if (appInstanceId == '68e691c4-d2b9-4e25-86dc-59bb48670dd4' || appInstanceId == 'pk_example') {
        params['public_key'] = "pk_example";
    } else {
        params['app_instance_id'] = appInstanceId;
    }

    url.search = new URLSearchParams(params).toString();

    const response = await getJSON(url.toString());
    return response;
}

export async function injectFeraFooter({ window, document }) {
    // Fera App Embed v1 for development environment
    const baseCdnUrl = feraConfig.cdnUrl;

    if (feraConfig.environment != 'production') window.feraEnvironment = feraConfig.environment;

    window.fera = window.fera || [];
    window.fera.push("configure", feraConfig);

    if (!document.querySelector('#fera_css')) {
    const element = document.createElement('link');element.href = `${ baseCdnUrl }fera.css`;element.id = "fera_css";element.rel = 'stylesheet';document.head.prepend(element);
    }

    if (!(window.fera && !Array.isArray(window.fera)) && !document.querySelector('#fera_js')) {
      const element = document.createElement('script');element.src = `${ baseCdnUrl }fera.js`;element.id = "fera_js";element.async = true; document.body.append(element);
    }
}

export async function setupWidget({ document, window, tempHtml, tempCss, element }) {
    await injectFeraFooter({ window, document });

    if (element.attributes['data-fera-needs-setup'] && element.attributes['data-fera-needs-setup'].value === 'true') {
        element.innerHTML = `Click here, then click <strong>Manage Reviews</strong>, then click <strong>Finish Setup</strong>.<br><br>Afterwards, refresh this page.`;
        element.style = `font-size: 4vw; color: red; text-shadow: 1px 1px 2px white;`;
    }

    console.log("Tag connected with attributes", element, element.attributes, element.properties, element.props);

    element.innerHTML = tempHtml;

    const style = document.createElement("style");
    style.innerHTML = tempCss;
    document.body.appendChild(style);

    if (window.fera && window.fera.version) {
        // Fera already loaded, so just refresh content
        window.fera.refreshContent();
    }
}